import { render } from "./ColorCircle.vue?vue&type=template&id=60f70ae0"
import script from "./ColorCircle.vue?vue&type=script&lang=js"
export * from "./ColorCircle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__